<template>
  <div class="ny-submenu">
    <template v-for="(item, index) in data">
      <!-- <el-submenu :index="getIndex(index)" v-if="item.children && item.children.length > 0"> -->
      <el-submenu :index="item.index" v-if="item.children && item.children.length > 0">
        <template slot="title">
          <i class="icon iconfont" :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </template>
        <!-- <submenu :data="item.children" :prefix="`${index+1}`"></submenu> -->
        <submenu :data="item.children"></submenu>
      </el-submenu>
      <!-- <el-menu-item :index="getIndex(index)" :route="{ path: item.path }" v-else> -->
      <el-menu-item :index="item.index" :route="{ path: item.path }" v-else>
        <i class="icon iconfont" :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Submenu',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    prefix: String
  },
  methods: {
    // getIndex (index) {
    //   return this.prefix ? this.prefix + '-' + (index + 1) : `${index + 1}`
    // }
  }
}
</script>
